import { SaleDetailModel } from 'api-hooks/sale/model';
import { HotelCheckInStatusEnum } from 'common/constants/enum';
import { generateId } from 'common/utils/string';
import { guestNameTransformer } from 'legacy-modules/sales/ticket-sale/hooks/use-get-default-values';
import React from 'react';

import {
  HotelRescheduleDetailAddOnsFormType,
  HotelRescheduleDetailFormType,
  HotelRescheduleDetailGuestFormType,
  HotelRescheduleDetailHotelFormType,
} from '../form-type';

export default function useGetDefaultValues(hotelSale: SaleDetailModel) {
  const defaultValues = React.useMemo(() => {
    const transactionAt = new Date();
    const hotelSales: HotelRescheduleDetailFormType[] =
      hotelSale.hotelSales.map((hs) => {
        const hotel = hs.hotel;
        const hotelSaleAddOns: HotelRescheduleDetailAddOnsFormType[] =
          hs.hotelSaleAddOns.map((hsao) => {
            const guest = hsao.guest;
            return {
              isSelected: true,
              id: hsao.id,
              guestId: guest.id,
              description: hsao.description || '',
              price: hsao.price || 0,
              priceUnit: hsao.priceUnit || 0,
              unit: hsao.unit || 0,
              guestName: guestNameTransformer(guest),
              customId: generateId(),
            };
          });
        const hotelSaleGuests: HotelRescheduleDetailGuestFormType[] =
          hs.hotelSaleGuests.map((hsg) => {
            const guest = hsg.guest;
            const guestPreferences = guest.preferences.map((ps) => {
              return {
                id: ps.id,
                label: ps.name,
              };
            });
            return {
              isLead: hsg.isLead || false,
              preferences: guestPreferences,
              id: hsg.id,
              guestId: guest.id,
              guestName: guest.name,
              customId: generateId(),
            };
          });
        const hotelSaleHotels: HotelRescheduleDetailHotelFormType[] =
          hs.hotelSaleHotels.map((hsh) => {
            const hotel = hsh.hotelRoom;
            return {
              checkIn: hsh.checkIn || null,
              checkOut: hsh.checkOut || null,
              detail: hsh.detail || '',
              pax: hsh.pax || 0,
              night: hsh.night || 0,
              room: hsh.room || 0,
              price: hsh.price || 0,
              checkInStatus:
                hsh.checkInStatus || HotelCheckInStatusEnum.NotAvailable,
              hotelConfirmationCode: hsh.hotelConfirmationCode || '',
              id: hsh.id,
              hotelRoomId: hotel.id,
              hotelRoomName: `${hotel.type} (${hotel.size})`,
              customId: generateId(),
            };
          });
        return {
          isSelected: false,
          bookingCode: hs.bookingCode || '',
          cityTax: hs.cityTax || '',
          customId: generateId(),
          hotelId: hotel.id,
          hotelName: hotel.name,
          hotelSaleAddOns,
          hotelSaleGuests,
          hotelSaleHotels,
          id: hs.id,
          isCityTax: hs.isCityTax || false,
          isByPax: hs.isByPax || false,
          originalHotelSaleHotels: hotelSaleHotels,
        };
      });

    return {
      invoiceNumber: hotelSale.invoiceNumber || '',
      customer: [
        hotelSale.customer.name,
        hotelSale.customer.alias,
        hotelSale.customer.phone,
      ]
        .filter((val) => !!val)
        .join(' - '),
      transactionAt,
      tempTransactionAt: transactionAt,
      hotelSales,
      hotelSale,
      total: 0,
    };
  }, [hotelSale]);

  return defaultValues;
}
